import { render } from "./AnalisiResults.vue?vue&type=template&id=71fe6730&scoped=true"
import script from "./AnalisiResults.vue?vue&type=script&lang=js"
export * from "./AnalisiResults.vue?vue&type=script&lang=js"

import "./AnalisiResults.vue?vue&type=style&index=0&id=71fe6730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fe6730"]])

export default __exports__